import { languageMap } from "../core"
import { bracketIndenting } from "./shared"

languageMap.v = bracketIndenting()
